import React, { useState } from 'react';
import { Button } from '../../../ui';
import classNames from 'classnames';
import priceCurrency from './priceCurrency.json';

const GiftCard = ({ active, onClick, currency }) => {
  const logos = [
    'semrush',
    'ahrefs',
    'gTmetrix',
    'keys',
    'keyCollector',
    'googleAnalytics',
    'megaindex',
    'checker',
    'g',
    'topvisor',
    'screamingFrog',
    'googleSearchConsole',
  ];

  return (
    <div
      className="cursor-pointer group relative flex justify-center items-center w-full max-w-[344px] h-[330px] md:max-w-[728px] md:h-[416px]"
      onClick={onClick}
    >
      <img
        className="hidden md:block filter transition-opacity w-full h-full absolute z-[1]"
        src="https://admin.weprodigi.com/uploads/images/seo/gift-default-new.png"
        alt="Layer"
      />
      <img
        className="block md:hidden filter  transition-opacity w-full h-full absolute z-[1]"
        src="https://admin.weprodigi.com/uploads/images/seo/gift-mob-default.png"
        alt="Layer"
      />

      <img
        alt="Layer"
        src="https://admin.weprodigi.com/uploads/images/seo/gift-hover-new.png"
        className={classNames(
          'hidden md:block filter   transition-opacity opacity-0 w-full h-full absolute z-[2]',
          !active && 'group-hover:opacity-100'
        )}
      />
      <img
        alt="Layer"
        src="https://admin.weprodigi.com/uploads/images/seo/gift-mob-hover.png"
        className={classNames(
          'block md:hidden  filter  transition-opacity opacity-0 w-full h-full absolute z-[2]',
          !active && 'group-hover:opacity-100'
        )}
      />

      <div className={classNames('shake absolute z-[30] flex items-center gap-[10px] ', active && 'opacity-0')}>
        <span className="mt-[30px] text-[24px] font-[400] leading-[30px] text-[#09af77]">Open the gift</span>{' '}
        <img src="/images/seo/icons/hand.svg" className="horizontal-shake h-[24px] mt-[30px]" alt="icon" />
      </div>

      <img
        alt="Layer"
        src="https://admin.weprodigi.com/uploads/images/seo/gift-expanded-new.png"
        className={classNames('hidden md:block filter transition-opacity opacity-0 w-full h-full absolute z-10', active && 'opacity-100')}
      />
      <img
        alt="Layer"
        src="https://admin.weprodigi.com/uploads/images/seo/gift-mob-expanded.png"
        className={classNames('block md:hidden filter transition-opacity opacity-0 w-full h-full absolute z-10', active && 'opacity-100')}
      />

      <div className={classNames('transition-opacity opacity-0 absolute inset-0 p-[48px] z-10', active && 'opacity-100')}>
        <div className="w-full h-full flex items-center"></div>
      </div>

      <div
        className={classNames(
          'transition-opacity opacity-0 absolute z-10 left-[25px] right-[25px] bottom-[72px] md:bottom-[87px] md:h-[50%] h-[55%] border border-t-0 border-purple',
          active && 'opacity-100'
        )}
      >
        <div className="bg-[#F5F5F5] md:-bottom-[24px] -bottom-[12px] left-1/2 transform -translate-x-1/2 text-[20px] md:text-[32px] h-[30px] md:h-[50px] flex flex-col items-center text-purple absolute px-[15px] gap-[7px] md:gap-10">
          <p>
            <span className="font-[700]">{priceCurrency[currency]}</span>&nbsp;worth
          </p>
          <a href={`/seo/seo-form`}>
            <Button variant="primary" narrowing="both" mode="light" className={'!py-[9px] !px-[30px] md:text-[18px] !text-[16px]'}>
              Claim My Gift
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default GiftCard;
